import { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import ChildPermissionAccord from './childAccord';
import { CustomToggle } from './customToggle';

const RightContentUiPermissions = ({ selectedOption, handleCheckboxChange, checkboxes }) => {
  const [modulePermission, setModulePermission] = useState(checkboxes);
  const [openAccordion, setOpenAccordion] = useState(null);

  useEffect(() => {
    setModulePermission(checkboxes);
  }, [checkboxes]);

  return (
    <div className="right-content">
      <h4>{selectedOption}</h4>
      <div className="sub-header">
        <Accordion defaultActiveKey="0" alwaysOpen>
          {modulePermission.menuPermissions.map(
            (menu, index) =>
              menu.permissionParentId === null && (
                <Card key={menu.permissionId}>
                  <Card.Header className="mainUIHeader">
                    <div>
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        style={{ marginRight: '5px' }}
                        checked={menu.canView}
                        onChange={() =>
                          handleCheckboxChange('menuPermissions', menu, menu.permissionId)
                        }
                      />
                      {menu.permissionDisplayName}
                    </div>
                    <CustomToggle eventKey={`P-${index}`} isOpen={openAccordion === `P-${index}`} />
                  </Card.Header>
                  <Accordion.Collapse eventKey={`P-${index}`}>
                    <Card.Body
                      style={{
                        background: '#f4f4ff',
                        padding: '15px',
                        minHeight: 'calc(100vh - 272px)',
                        maxHeight: 'calc(100vh - 272px)',
                        overflow: 'auto',
                      }}
                    >
                      {modulePermission.menuPermissions.length > 1 && (
                        <Accordion defaultActiveKey="0" className="subAccordion" alwaysOpen>
                          {modulePermission.menuPermissions.map(
                            (menu, index) =>
                              menu.permissionParentId !== null && (
                                <Card key={menu.permissionId}>
                                  <Card.Header className="mainUIHeader">
                                    <div>
                                      <input
                                        type="checkbox"
                                        name=""
                                        id=""
                                        style={{ marginRight: '5px' }}
                                        checked={menu.canView}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            'menuPermissions',
                                            menu,
                                            menu.permissionId
                                          )
                                        }
                                      />
                                      {menu.permissionDisplayName}
                                    </div>
                                    <CustomToggle
                                      eventKey={index.toString()}
                                      isOpen={openAccordion === index.toString()}
                                    />
                                  </Card.Header>
                                  <Accordion.Collapse eventKey={index.toString()}>
                                    <Card.Body
                                      style={{
                                        background: '#f4f4ff',
                                        padding: '15px',
                                        minHeight: 'calc(100vh - 272px)',
                                        maxHeight: 'calc(100vh - 272px)',
                                        overflow: 'auto',
                                      }}
                                    >
                                      <ChildPermissionAccord
                                        menu={menu}
                                        handleCheckboxChange={handleCheckboxChange}
                                        openAccordion={openAccordion}
                                        setOpenAccordion={setOpenAccordion}
                                        index={index}
                                      />
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              )
                          )}
                        </Accordion>
                      )}
                      <ChildPermissionAccord
                        menu={menu}
                        handleCheckboxChange={handleCheckboxChange}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index={index}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )
          )}
        </Accordion>
      </div>
    </div>
  );
};

export default RightContentUiPermissions;
